<ng-container *ngIf="!isReadOnlyBooking && inquiry">
  <ng-container *ngIf="!isAirbnbAPIBooking">
    <ng-template
      [ngTemplateOutlet]="confirmBtn"
      *ngIf="!isBooked && !isAirbnbAPIInquiry && !isBdcRtbRequest"
    ></ng-template>
    <ng-template [ngTemplateOutlet]="cancelBtn" *ngIf="isBooked"></ng-template>
  </ng-container>
  <ng-container *ngIf="isAirbnbAPIBooking">
    <ng-template [ngTemplateOutlet]="airbnbActionsTmpl"></ng-template>
  </ng-container>
</ng-container>

<ng-template #cancelBtn>
  <app-button
    *ngIf="!isVrbo && !isHolidu"
    icon="fal fa-ban"
    class="btn btn-secondary-danger"
    [class.btn-sm]="btnSm"
    (click)="onCancelBooking()"
    [loading]="isCanceling$ | async"
    i18n-matTooltip
    matTooltip="Cancel Booking"
    i18n
    >Cancel</app-button
  >

  <ng-container *ngIf="isVrbo">
    <div dropdown class="btn-group">
      <app-button
        dropdownToggle
        icon="fal fa-ban"
        class="btn btn-secondary-danger"
        [class.btn-sm]="btnSm"
        [loading]="isCanceling$ | async"
        i18n-matTooltip
        matTooltip="Cancel Booking"
        i18n
        >Cancel</app-button
      >
      <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
        <li>
          <button i18n (click)="onCancelBooking(true)" type="button">Cancelled by Guest</button>
        </li>
        <li>
          <button i18n (click)="onCancelBooking()" type="button">Cancelled by Property Manager</button>
        </li>
      </ul>
    </div>
    <app-button
      icon="far fa-user"
      *ngIf="isVrboAlterationInitiated"
      class="btn btn-secondary-info"
      [class.btn-sm]="btnSm"
      (click)="onVrboAlteration()"
      matTooltip="Review alteration sent to or received by guest."
      i18n-matTooltip
    >
      <ng-container i18n> Change Pending </ng-container>
    </app-button>
  </ng-container>

  <div *ngIf="isHolidu" dropdown class="btn-group">
    <app-button
      dropdownToggle
      icon="fal fa-ban"
      class="btn btn-secondary-danger"
      [class.btn-sm]="btnSm"
      [loading]="isCanceling$ | async"
      i18n-matTooltip
      matTooltip="Cancel booking"
      i18n
    >
      Cancel
    </app-button>
    <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" style="max-height: 300px; overflow: auto">
      <li *ngFor="let item of holiduCancelReasons">
        <button (click)="onCancelBookingWithReason(item.id)" type="button">
          {{ item.label }}
        </button>
      </li>
    </ul>
  </div>
</ng-template>

<ng-template #confirmBtn>
  <app-button
    matTooltip="Confirm booking"
    i18n-matTooltip
    matTooltipPosition="below"
    icon="fal fa-check-square"
    class="btn btn-secondary-info"
    [class.btn-sm]="btnSm"
    (click)="onConfirmBooking()"
    [loading]="isConfirmingBooking$ | async"
    i18n
    >Confirm Booking</app-button
  >
</ng-template>

<ng-template #airbnbActionsTmpl>
  <ng-container *ngIf="bookingStatus === 'pending'">
    <app-button
      (click)="onAcceptAirbnbBooking(inquiry)"
      icon="fal fa-check-square"
      [loading]="isLoading"
      class="btn btn-secondary-info"
      [class.btn-sm]="btnSm"
      i18n
      >Accept</app-button
    >
    <app-button
      (click)="onDeclineAirbnbBooking(inquiry)"
      icon="fal fa-ban"
      [loading]="isLoading"
      class="ml-3 btn btn-secondary-danger"
      [class.btn-sm]="btnSm"
      i18n
      >Decline</app-button
    >
  </ng-container>

  <app-button
    *ngIf="bookingStatus === 'accept'"
    icon="fal fa-ban"
    class="btn btn-secondary-danger"
    [class.btn-sm]="btnSm"
    (click)="onCancelAirbnbBooking()"
    [loading]="isCanceling$ | async"
    i18n-matTooltip
    matTooltip="Cancel Booking"
    i18n
    >Cancel</app-button
  >

  <ng-template [ngTemplateOutlet]="airbnbAlterationTmpl" *ngIf="isAirbnbChangeable"></ng-template>
</ng-template>

<ng-template #airbnbAlterationTmpl>
  <ng-container *ngIf="!airbnbAlteration || isAirbnbAlterationInitiated">
    <app-button
      icon="fab fa-airbnb"
      class="btn btn-secondary-info"
      [class.btn-sm]="btnSm"
      (click)="onAirbnbAlteration()"
      *ngIf="!isAirbnbAlterationInitiated"
      matTooltip="Send Alteration request to guest to change this booking."
      i18n-matTooltip
    >
      <ng-container i18n> Change </ng-container>
    </app-button>
    <app-button
      icon="fab fa-airbnb"
      *ngIf="isAirbnbAlterationInitiated"
      class="btn btn-secondary-info"
      [class.btn-sm]="btnSm"
      (click)="onAirbnbAlteration()"
      matTooltip="Review alteration sent to or received by guest."
      i18n-matTooltip
    >
      <ng-container i18n> Change Pending </ng-container>
    </app-button>
  </ng-container>
</ng-template>
